/**
 * Observations canceladas ou em erro não entram na visualização FluxHealth.
 */
export function isActiveWearableObservationEntry(entry: unknown): boolean {
  const status = String(
    (entry as { resource?: { status?: string } })?.resource?.status ?? "",
  ).trim();
  return status !== "cancelled" && status !== "entered-in-error";
}

/** Id lógico da Observation — resource.id ou Observation/{id} no fullUrl. */
export function extractObservationIdFromEntry(entry: unknown): string {
  const resourceId = String(
    (entry as { resource?: { id?: string } })?.resource?.id ?? "",
  ).trim();
  if (resourceId) return resourceId;

  const fullUrl = String((entry as { fullUrl?: string })?.fullUrl ?? "").trim();
  if (!fullUrl) return "";

  const withoutHistory = fullUrl.split("/_history")[0];
  const match = withoutHistory.match(/Observation\/([^/?]+)/i);
  return match?.[1]?.trim() ?? "";
}

/** Extrai ids FHIR válidos de entries de Observation. */
export function collectWearableObservationIds(entries: unknown[]): string[] {
  const ids = new Set<string>();
  for (const entry of entries) {
    const id = extractObservationIdFromEntry(entry);
    if (id) ids.add(id);
  }
  return Array.from(ids);
}
